/**
 * Created by dx.yang on 2017/3/20.
 */


import {KecPath, Service, Version, source,noLoginKecApi} from './constants';

export const RegionList = {
    basePath: KecPath,
    params: {
        Action: 'RegionList',
        Service,
        Version,
        source
    }
};

export const RegionInfos = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'RegionInfos',
        Service: 'kec',
        Version,
        source
    }
};

// 获取图标的数据
export const getDataApi = {
    method: 'post',
    basePath: '/monitorapi/dashboard/querydata',
    params: {
        Service,
        source
    }
};
export const getDataApiV2 = {
    method: 'post',
    basePath: '/monitorapi/v2/dashboard/querydata',
    params: {
        Service,
        source
    }
};
//检查用户快照开通状态
export const DescribeSnapshotUsageStatus = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshotUsageStatus',
        Service: 'kec',
        Version,
        source
    }
};
//描述快照状态
export const DescribeSnapshotServiceStatus = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshotServiceStatus',
        Service: 'kec',
        Version,
        source
    }
};
//检查用户是否开通快照服务
export const checkSnapShotPermission = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CheckSnapShotPermission',
        Service: 'kec',
        Version,
        source
    }
};

//开通快照服务（开通订单）
export const openSnapShotService = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'OpenSnapShotService',
        Service: 'kec',
        Version,
        source
    }
};
//加密用户白名单
export const DistributeKmsPermission = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DistributeKmsPermission',
        Service: 'kec',
        Version,
        source
    }
};

//黑名单用户，在名单里的返回true，新建实例的时候跳转老版本
export const UserListForKPC = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'UserListForKPC',
        Service: 'kec',
        Version,
        source
    }
};

export const CheckUserDbscRight = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CheckUserDbscRight',
        Service,
        Version: '2016-03-04',
        source,
    }
};

// 未登录
export const noLoginRegionList = {
    basePath: noLoginKecApi,
    params: {
        Action: 'RegionList',
        Service,
        Version,
        source
    }
};

export const checkVncPermission = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'CheckVncPermission',
        Service: 'kec',
        Version,
        source
    }
};
export const DescribeQuotaCount = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeQuotaCount',
        Service,
        Version,
        source
    }
};
